import { render, staticRenderFns } from "./unbindBankCard.vue?vue&type=template&id=50ba4bb2&scoped=true"
import script from "./unbindBankCard.vue?vue&type=script&lang=js"
export * from "./unbindBankCard.vue?vue&type=script&lang=js"
import style0 from "./unbindBankCard.vue?vue&type=style&index=0&id=50ba4bb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba4bb2",
  null
  
)

export default component.exports